import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { getOwner } from '@ember/application';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import MasqService from 'cio/services/masq';
import RouterService from '@ember/routing/router-service';
import DS from 'ember-data';
import SettingsController from 'cio/pods/settings/controller';
import Transition from '@ember/routing/-private/transition';
import FeaturesService from 'ember-feature-flags/services/features';
import AppRoute from 'cio/pods/app/route';
import BillingService from 'cio/services/billing';

export default class SettingsRoute extends Route {
  @service auth!: AuthService;
  @service account!: AccountService;
  @service masq!: MasqService;
  @service router!: RouterService;
  @service store!: DS.Store;
  @service features!: FeaturesService;
  @service billing!: BillingService;

  crumb() {
    return {
      name: 'Account Settings',
      path: this.routeName,
      helpQuery: 'account information billing',
    };
  }

  async model() {
    await this.billing.initialize({ refresh: true, paramPlanSlug: '', code: '', ignoreErrors: true });
    return this.account.current;
  }

  setupController(controller: SettingsController, model: unknown) {
    controller.set('account', model);
  }

  async afterModel(model: unknown, transition: Transition) {
    if (this.store.peekAll('object-type').length === 0) {
      // wrapping in try catch as there were issues when masquerading and going to /settings
      try {
        await this.store.findAll('object-type');
      } catch {}
    }

    return super.afterModel(model, transition);
  }

  @action
  willTransition(transition: Transition) {
    // "app" route executes checks against account state to prevent suspended/overdue accounts from using the app
    // depending on user role, it redirects to "settings.team" or "settings.subscription" routes
    // we need to re-trigger account state checks when navigating between settings child routes
    // i.e. trying to access "settings.index" by clicking "Account settings" link in header account dropdown
    let app = getOwner(this);
    // this allows us to skip the beforeModel below so that when someone is limited to the billing routes they can
    // click between any of the tabs in settings/billing without being forced back to one specific tab
    if (this.router.currentRouteName.includes('settings.billing') && transition.to.name.includes('settings.billing')) {
      return;
    }
    return (app.lookup('route:app') as AppRoute).beforeModel(transition);
  }
}
